import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private apiUrl = environment.language_api; 
 
  availableLangs: string[] = [];

  constructor(private http: HttpClient) {}

  getOpciones(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getLanguageContent(languageId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${languageId}/file`).pipe(
      map(response => response.result.item.url),
      switchMap(fileUrl => this.http.get(fileUrl))
    );
  }
  
  loadLanguages(): Promise<string[]> {
    return this.http.get<any>(this.apiUrl)
      .toPromise()
      .then(res => {
        const langs = res.result.items.map((lang: any) => lang.code); 
        return Array.from(new Set(langs.map(lang => lang.toLowerCase())));
      });
  }
}
